import { GetServerSideProps } from 'next'
import React, { FC } from 'react'

import { BlogResponse, fetchBlog, retrieveQAFeed, retriveBlogList } from '../../api/feed'
import { retrieveSeoData } from '../../api/seo'
import BlogPage from '../../components/BlogPage'
import MetaTags from '../../components/MetaTags'
import { CustomisedFeedObjectQuestion } from '../../components/NewQuestion'
import { normailzeData } from '../../components/NewQuestion/utils'
import { getLocale, localeToLanguage } from '../../data/intl'
import { homePage } from '../../data/pages'
import useScreenName from '../../hooks/clevertap/useScreenName'
import { useLingui } from '../../hooks/locale/useLingui'
import { BlogItem, FeedAge, PageMetadata } from '../../interfaces'
import { getQuery } from '../../utils/utm'

const pageName = 'Blog Page'

const defaultAgeType = 'ALL'

interface Props {
  blogDetails: BlogResponse
  blogDataList: Array<BlogItem>
  qaDataList: Array<CustomisedFeedObjectQuestion>
  seoData?: PageMetadata
}

const Blog: FC<Props> = props => {
  const ScreenProvider = useScreenName(pageName)
  const title = props?.blogDetails?.payload?.title ? `${props?.blogDetails?.payload?.title} | Healofy` : 'Healofy'
  const LinguiProvider = useLingui()
  return (
    <ScreenProvider>
      <MetaTags ogTitle='Indian Pregnancy, Parenting & Baby Products Shopping platform' seoData={props.seoData} title={title} />
      <LinguiProvider>
        <div className='bg-w'>
          <BlogPage {...props} />
        </div>
      </LinguiProvider>
    </ScreenProvider>
  )
}

export const getServerSideProps: GetServerSideProps<Props> = async ctx => {
  const ageType = (getQuery(ctx.query?.ageType) ?? defaultAgeType).toUpperCase()
  const feedAge = (getQuery(ctx.query?.feedAge) ?? 'ALL').toUpperCase() as FeedAge
  const slug = getQuery(ctx.query.slug) ?? ''
  const locale = getLocale(ctx.locale)
  const language = localeToLanguage(locale)

  const [qaDataList, blogDataList, blogDetails, seoData] = await Promise.all([
    retrieveQAFeed(locale, ageType, feedAge, 0),
    retriveBlogList(feedAge, defaultAgeType, language, 0, 'LIFESTAGE'),
    fetchBlog(slug),
    retrieveSeoData(ctx.resolvedUrl),
  ])

  if (!blogDetails?.payload?.id) {
    return { redirect: { destination: homePage, permanent: true } }
  }

  return { props: { blogDetails, qaDataList: normailzeData(qaDataList), blogDataList: blogDataList.payload?.blogs ?? [], seoData } }
}

export default Blog
